import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <Typography variant="body2" color="textSecondary" align="center" style={styles.footerText}>
        {'Copyright © '}
        <Link color="inherit" href="https://kintelligence.com.br" target="_blank">
          K-Intelligence
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    </footer>
  );
}

let styles = {
  footer: {
    marginTop: 50,
    position: 'relative',
  },
  footerText: {
    color: '#E5E6F0'
  }
};
